import React from "react";
import MailchimpReact from "mailchimp-react";
import { Subscribe } from "./Subscribe";
import rocks from "../assets/img/rocks-darker.png";
import esrb from "../assets/img/esrb-rp.svg";
import nisa from "../assets/img/brand-nisa.png";
import nintendo from "../assets/img/brand-nintendo.svg";
import ps4 from "../assets/img/brand-ps4.svg";
import ps4Symbol from "../assets/img/brand-ps4-symbol.svg";
import yummy from "../assets/img/brand-yummy.png";
import { isIOS } from "react-device-detect";

export const Footer = () => {
  return (
    <footer className="flex end">
      <img
        src={rocks}
        className="rocks"
        alt=""
        style={{
          pointerEvents: "none",
          visibility: isIOS ? "hidden" : "visible",
        }}
      />

      <div
        className="footer-content flex end"
        style={{ position: "absolute", width: "90%" }}
      >
        <div className="brands flex row wrap" style={{ width: "90%" }}>
          <img src={esrb} alt="" height="80px" />
          <div className="flex row" style={{ margin: "16px" }}>
            <img
              src={ps4Symbol}
              alt=""
              height="48px"
              style={{ marginRight: "8px" }}
            />
            <img src={ps4} alt="" height="20px" />
          </div>
          <img src={nintendo} alt="" height="64px" />
          <img src={nisa} alt="" height="64px" />
          <img src={yummy} alt="" height="84px" />
        </div>

        <p
          style={{
            color: "white",
            fontWeight: "lighter",
            padding: "16px",
            paddingTop: 0,
            textAlign: "center",
            fontFamily: "Arial",
            fontSize: "initial",
            backgroundColor: "initial",
            width: "initial",
          }}
        >
          ©YummyYummyTummy, Inc. Licensed to and published by NIS America, Inc.
          <br />"<span style={{ fontFamily: "SCE" }}>2</span>”, "PlayStation"
          and “<span style={{ fontFamily: "SCE" }}>=</span>” are trademarks or
          registered trademarks of Sony Interactive Entertainment Inc.
          <br />
          Nintendo Switch is a trademark of Nintendo.
          <br />
          The rating icon is a trademark of the Entertainment Software
          Association.
          <br />
          All other trademarks are properties of their respective owners.
        </p>
      </div>
    </footer>
  );
};
